export default function LinkImage() {
    return (
        <img
            className="linkimage"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgBrVK7TgJRED0zS2LsLG0UY2KlFvZiKC2xMVtiZ2f8ApYvWP7AtYMKPoFHww+QUBK+ADoo2MvMwCYbssCScJqbO3fm3DNnhpCg9Fkh8A8RythB3G+Snvzmu90359CV4D8GzchyLPrq15i4nUV2DFrDhD/lsDtKftUCm+9+Y28ZoduZ5WIrV654dVEV1tA6cfGHR8WnUH65M7JBq4HJeIG8kFw3HQ3p9nEupO+i77qQtGnKUsjyK43E103tZcTxIrT2cWYUdEqmUr0AGlkKjmK1FB91IOh5KD7PhdAn8cCpF/cP49w+ylBw8/LN5Gwo5FBP9iuQo7av7tAeplCXvIC3BYGwf6lknAitIVkX5dD7GqFaZfhzL6dgAAAAAElFTkSuQmCC"
            alt=""
        />
    );
}
